import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-h7-bold-light",
  "use": "icon-h7-bold-light-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-h7-bold-light\">\n<path d=\"M2.995 6.7793V18.2033H4.867V13.1473H10.659V18.2033H12.531V6.7793H10.659V11.5473H4.867V6.7793H2.995Z\" fill=\"#007AF5\" />\n<path d=\"M16.175 11.0804V12.1404H19.825L17.265 18.2204H18.505L21.005 12.0204V11.0804H16.175Z\" fill=\"#007AF5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol